module.exports = __webpack_public_path__ + "static/media/linkedin.1024bc39.png";